import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { debounce } from 'lodash';
import { connect } from 'react-redux'
import Jwplayer from '../JWPlayerContainer/Jwplayercontainer';
import Moment from 'react-moment';
import moment from 'moment/min/moment-with-locales';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay , faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import VideoHolder from './VideoStyles';
import {getLabel, formatLocalDate, resizeHandler, truncateWords, smallerImage} from '../../utils';

import SharePage from '../SharePage/SharePage';
import {useMediaQuery} from "react-responsive";

const Video = props => {
	const [videoLang, setVideoLang] = useState(null);
	const [chgSize, setChgSize] = useState(false);
	const [playlist, setPlaylist] = useState({});
	const [isInVideoPage, setIsInVideoPage] = useState(false);
	const [isInLandingPage, setIsInLandingPage] = useState(false);
	const [isLiveNow , setIsLiveNow] = useState(false);
	const [newUrl , setNewUrl] = useState(null);
	const [audioButtons , setAudioButtons] = useState(null);
	const [btnClicked , setBtnClicked] = useState(null);
	const thumbContainer = useRef(null);
	const [lastDateModified, setLastDateModified] = useState();
	const [duration, setDuration] = useState(null);

	// lg 768 (1536 retina), md 576 (1152 retina), sm 269 (538 retina)
	// full
	const is1090_ = useMediaQuery({query: '(min-width: 1090px)' })
	const is769_920 = useMediaQuery({query: '(min-width: 769px) and (max-width: 920px)' })
	// lg
	const is577_768 = useMediaQuery({query: '(min-width: 577px) and (max-width: 768px)'})
	const is921_1089 = useMediaQuery({query: '(min-width: 921px) and (max-width: 1089px)'})

	const isMd = useMediaQuery({query: '(min-width: 270px) and (max-width: 576px)'})
	const isSm = useMediaQuery({query: '(max-width: 269px)'})
	const imgSz = (is1090_||is769_920) ? "full" : (is577_768||is921_1089) ? "lg" : isMd ? "md" : isSm ? "sm" : null;
	useEffect(()=>{
		resizeHandler('.video-thumb-container');

		window.addEventListener('resize', debounce(function() {
			resizeHandler('.video-thumb-container');
		},300));

		return ()=> window.removeEventListener('resize',()=>resizeHandler('.video-thumb-container'));
	},[]);

	useEffect(() => {
		if (thumbContainer && thumbContainer.current) {
			resizeHandler('.video-thumb-container');
		}
	}, [thumbContainer.current]);

	useEffect(()=> {
		const tmpPlayList = {
			"title": props.details.title,
			"description": props.details.description,
			"category": props.details.category,
			"image": smallerImage(props.details.image, imgSz),
			"file": newUrl !== null ? newUrl : props.details.videoUrl
		};
		if(props.details.videoUrl) {
			setPlaylist(tmpPlayList);
			setVideoLang(props.current_lang);
		}
		if(props.details.type !== "cpactv"){
			if(props.details.liveDateTime && props.details.lastDateModified && props.details.liveDateTime > props.details.lastDateModified){
				setLastDateModified(props.details.liveDateTime); 
			} else {
				setLastDateModified(props.details.lastDateModified); 
			}
			setDuration(moment.duration(props.details.videoDuration).toISOString());
		}
		
		window.location.search !== "" && window.location.search !== undefined ? setIsInVideoPage(true) : setIsInVideoPage(false);
		props.isLanding ? setIsInLandingPage(true) : setIsInLandingPage(false);

	},[props.details.image, props.details.videoUrl, props.isInLandingPage, props.details.lastDateModified, newUrl]);

	useEffect(()=> {
		Moment.globalMoment = moment;

		if(props.current_lang === "en") {
			moment.locale("en");
			Moment.globalLocale = 'en';
		} else {
			moment.locale("fr");
			Moment.globalLocale = 'fr';
		}

	},[props.current_lang]);
	
	useEffect(()=> {
		if(props.onChangeSize) {
			props.onChangeSize(chgSize);
		}
	},[chgSize]);

	const audioClickedCB = (clicked) => {
		setBtnClicked(clicked);
	}

	const audioLangClickHandler = (lang) => {
		setVideoLang("no-lang");
		setBtnClicked(true);

		setTimeout(()=> {
			if(lang !== "en" && lang !== "fr") {
				setVideoLang("Floor");
			} else {
				setVideoLang(lang);
			}
		},50);

	}

	const chgSizClickHandler = () => {
		chgSize ? setChgSize(false) : setChgSize(true);
	}

	const renderTags = () => {
		return props.tags.map((tag, index)=>{
			return (
				<a href={tag.url} key={index}>
					<div className="article-tag">
						<img alt="tag icon" className="tag-icon" src="/static-assets/theme/svg/tag.svg" /><span itemProp="keywords">{tag.name}</span>
					</div>
				</a>
			)
		})
	}

	const renderAudioBtns = () => {
		return audioButtons.map((button,i)=> {
			return (
				<button key={`audio-btn-${i}`} onClick={() => audioLangClickHandler(button.lang)}>
					<FontAwesomeIcon icon={faPlay}/>
					{(button.name !== "English" && button.name !== "French")
						? getLabel("FLOOR") 
						: getLabel(button.name.toUpperCase())
					}
				</button>
			);
		});
	}

	const renderWide = () => {
		if(!chgSize) {
			return (
				<>
					<span>{getLabel("WIDE_PLAYER")}</span>
					<FontAwesomeIcon icon={faArrowRight}/> 
				</>
			)	
		} else {
			return (
				<>
					<span>{getLabel("CONSTRAIN_PLAYER")}</span>
					<FontAwesomeIcon icon={faArrowLeft}/>
				</>
			)
		}	
	}
	//description render
	const renderDescription = () => {
		const regX = /\n/g;
		const fixedDescription = props.details.description ? props.details.description.replace(regX,"<br>") : ""; 
		return(
			isInVideoPage ? 
			<p className="description" tabIndex="0" dangerouslySetInnerHTML={{ __html: fixedDescription }}></p>
			:
			isInLandingPage ? 
			<p className="description-landing" tabIndex="0" dangerouslySetInnerHTML={{ __html: fixedDescription }}></p>
			:
			<p className="description description__container-relative" tabIndex="0" itemProp="description">
				{ props.details.description && truncateWords(props.details.description, 225) }
				{props.details.description && props.details.description.length > 225 && (
					<span className="description__ellipsis" onClick={() => (window.location.href = props.details.url)}>(...)</span>
				)}
			</p>
		);
	}

	const renderCounter = () => {
		const eventDateUTC = formatLocalDate(props.details.liveDateTime);
		const eventDateLocal = new Date(eventDateUTC);

		const liveTimer = setInterval(() => {
			const now = moment(new Date());
			const isAfter = now.isAfter(eventDateLocal, 'seconds');

			if(isAfter) {
				setIsLiveNow(isAfter);
				
				const serviceUrl = process.env.REACT_APP_EPISODE_INFO_ENDPOINT
				const episodeId = props.details.episodeId;

				axios.get(`${serviceUrl}?id=${episodeId}`)
				.then(function (response) {
					setNewUrl(response.data.component.details.videoUrl);
				})

				clearInterval(liveTimer);
			}

		},1000);

		return (
			<div className="live-info">
				{getLabel("LIVE")}<Moment interval={1000} date={eventDateLocal} fromNow/>
			</div>
		)
	}
	
	const renderJWPlayer = () => {
		if(props.processPrelive && props.details.type === "prelive" && !isLiveNow && newUrl === null) {
			return (
				<div className="video-thumb-container" ref={ thumbContainer }>
					<div className="video-thumb-header">
						<img className="video-thumb"
							 src={smallerImage(props.details.image, imgSz)}
							 alt={props.details.altImageTxt} itemProp="thumbnailUrl" />
						{renderCounter()}
					</div>
				</div>	
			)
		} else {
			if (playlist && playlist.file && videoLang) {
				return (
					<div itemProp="video">
					<meta itemProp="thumbnailUrl" content={props.details.image} />
					<Jwplayer
						lang={ videoLang }
						playlist={ playlist }
						setShowCPACTV={ isInVideoPage && isInLandingPage ? null : props.setShowCPACTV }
						autoplay={isLiveNow}
						setAudiosCB={(audioList)=>setAudioButtons(audioList)}
						btnClicked={btnClicked}
						audioClickedCB={(clicked)=>audioClickedCB(clicked)}
						vType={props.details.type}
					/>
					</div>
				)
			}
		}
	}
	
	const videoSchemaType = () => {
		return props.details.type !== "cpactv" ? "https://schema.org/VideoObject" : "https://schema.org/Episode"
	}

	return (
		<VideoHolder className={chgSize ? "wide" : ""}>
				<div itemScope itemType={videoSchemaType()}>
				<meta itemProp="name" content={props.details.title}/>
				<meta itemProp="description" content={props.details.description}/>
				{props.processPrelive && props.details.type === "live" &&
				<meta itemScope='itemscope' itemType='https://schema.org/BroadcastEvent' itemProp='isLiveBroadcast' />}
				{ renderJWPlayer() }
				{lastDateModified && <meta itemProp="uploadDate" content={lastDateModified} />} 
				<div className="video-info">
					<div className={`video-info__btns-cont ${isInLandingPage ? "centered" : ""}`}>
						{ audioButtons && audioButtons.length > 0 && renderAudioBtns() }
						<button className={isInLandingPage || props.hOnlyItem === true ? "hide" : ""} onClick={chgSizClickHandler}>{renderWide()}</button>
					</div>
					<div className="video-info__details-cont">
						<meta itemProp={`${props.details.type !== "cpactv" ? 'contentUrl' : 'url'}`} content={props.details.videoUrl} />
						{props.details.videoDuration && 
							<meta itemProp='duration' content={duration} />
						}
						<div itemScope='itemscope' itemType='https://schema.org/ReportageNewsArticle'>
							<a href={props.details.categoryURL} className={`category ${isInLandingPage ? "hide" : ""}`}>
							<span itemProp='isPartOf'>{props.details.category}</span></a>
							<a href={props.details.url} className={`title ${isInVideoPage ? "in-video-page" : isInLandingPage ? "in-landing-page": ""}`} tabIndex="0"><span itemProp='headline'>{props.details.title}</span></a>
							<meta itemProp="articleBody" content={props.details.description} />
							<meta itemProp="image" content={props.details.image}/>
							{ renderDescription() }
						</div>
					</div>
					{ props.tags && props.tags.length > 0 && 
						<div className="article-tag-container">
							{renderTags()}
						</div>
					}
					{ isInVideoPage && <SharePage/> }
				</div>
			</div>
		</VideoHolder>
	)
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current
});

export default connect(mapStateToProps, null)(Video);